import React, { useState } from "react";
import { Form, Input, Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { ENTERPRISE_ROLE } from "../../../../constant";
import { useDispatch, useSelector } from "react-redux";
import { addList } from "../../../../store/actions/leads-list";

const AddListModal = ({ preview, previewHandler }) => {
  // STATES
  const [isLoading, setLoading] = useState(false);

  // REDUX DATA
  const user = useSelector((state) => state.UserReducer.profile);
  const selectedCompany = useSelector((state) => state.CompanyReducer.selected_company);

  // CONST VALS
  const dispatch = useDispatch();
  const { http } = global.services;
  const [form] = Form.useForm();
  const isEnterpriseUser = user?.role === ENTERPRISE_ROLE;

  // HANDLERS
  const submitHandler = (values) => {
    setLoading(true);
    // TODO: uncomment this when we restrict professional users from accessing enterprise features
    // const url = `user-lead-list${isEnterpriseUser ? `/${selectedCompany.id}` : ""}`;
    const url = `user-lead-list/${selectedCompany.id}`;
    http
      .post(url, values)
      .finally(() => setLoading(false))
      .then(({ data }) => {
        toast.success("List created successfully");
        dispatch(addList(data));
        previewHandler();
        form.resetFields();
      })
      .catch((error) => {
        const message = error?.response?.data?.error || "Something went wrong";
        toast.error(message);
      });
  };

  return (
    <Modal
      visible={preview}
      centered
      className="add-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Add Leads List</h2>
      <p>Enter name of list below</p>
      <Form form={form} onFinish={submitHandler}>
        <label htmlFor="name">Name</label>
        <Form.Item
          name="name"
          rules={[
            { required: true, message: "List name is required" },
            {
              max: 100,
              message: "List name cannot be more than 100 characters",
            },
          ]}
        >
          <Input type="text" placeholder="Enter list name" />
        </Form.Item>
        <div className="action-box">
          <button type="button" onClick={previewHandler}>
            Cancel
          </button>
          <button className="submit" type="submit">
            {isLoading ? <BeatLoader size={8} color="#fff" /> : "Submit"}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddListModal;
